import styled from 'styled-components'
import { Handle } from '@xyflow/react'

// Collapsed view wrapper - fixed size container for stable handle positioning
// NO transform here - React Flow needs stable handle positions for edge routing
// z-index ensures nodes render above edges
export const CollapsedViewWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  /* Fixed size - handles at left/right edges */
  width: 32px;
  height: 32px;
  z-index: 1;
`

// Circular icon node at center - this is where edges connect
// Children (AI indicator, tags) are positioned relative to this
export const CollapsedCircle = styled.div<{ $iconColor: string }>`
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%) scale(var(--zoom-scale-raw, 1));
  transform-origin: left center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--color-node-bg);
  border: 2px solid ${(props) => props.$iconColor};
  box-shadow: var(--shadow-collapsed);

  /* Branch selection mode highlight for collapsed nodes */
  .branch-selected & {
    box-shadow:
      0 0 0 4px var(--color-primary, #6e53f9),
      0 0 12px 2px var(--color-primary-shadow, rgba(110, 83, 249, 0.35));
  }
`

// Tags container - child of CollapsedCircle, positioned below it
export const CollapsedTagsContainer = styled.div`
  position: absolute;
  left: 50%;
  top: 100%;
  transform: translateX(-50%);
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  align-items: center;
`

// Individual tag circle in collapsed view
export const CollapsedTagCircle = styled.div<{ $color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${(props) => props.$color};
  border: 1px solid var(--color-node-bg);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
`

// Fixed-position target handle for collapsed view - stays at left edge regardless of content size
// pointer-events: none !important to override ReactFlow's .connectionindicator { pointer-events: all }
export const CollapsedTargetHandle = styled(Handle)`
  opacity: 0;
  width: 16px;
  height: 16px;
  position: absolute;
  left: -8px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none !important;
`

// Fixed-position source handle for collapsed view - absolutely positioned at right edge of card
// pointer-events: none !important to override ReactFlow's .connectionindicator { pointer-events: all }
export const CollapsedSourceHandle = styled(Handle)`
  opacity: 0;
  width: 16px;
  height: 16px;
  position: absolute;
  right: -8px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none !important;
`
